import { render, staticRenderFns } from "./WideModal.vue?vue&type=template&id=5e16429a&scoped=true&"
import script from "./WideModal.vue?vue&type=script&lang=js&"
export * from "./WideModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e16429a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e16429a')) {
      api.createRecord('5e16429a', component.options)
    } else {
      api.reload('5e16429a', component.options)
    }
    module.hot.accept("./WideModal.vue?vue&type=template&id=5e16429a&scoped=true&", function () {
      api.rerender('5e16429a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WideModal.vue"
export default component.exports